import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import {CaseThirdPartyConsent} from '@secca/shared/models/caseThirdPartyConsent';
import { ThirdPartyConsentStatusEnum } from '@secca/shared/models/enums';

@Component({
  selector: 'app-drop-down-third-party-consent',
  templateUrl: './drop-down-third-party-consent.component.html',
  styleUrl: './drop-down-third-party-consent.component.scss',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})

export class DropDownThirdPartyConsentComponent {
  @ViewChild('thirdPartyConsentSelect') private thirdPartyConsentSelect: NgSelectComponent;
  @Input() selectedItemId: CaseThirdPartyConsent;
  @Input() itemsThird: CaseThirdPartyConsent[];
  @Input() loading: boolean;
  @Input() stakeholderName: string;
  @Input() stakeholderRemark: string;
  @Output() saveModel = new EventEmitter();
  @Output() selectedItemIdChange = new EventEmitter();
  @Output() open = new EventEmitter();

  thirdPartyConsentMouseOver = false;

  constructor() { }

  ngOnInit() {  }

  focus() {
    this.thirdPartyConsentSelect.open();
  }

  onOpen() {
    this.open.emit();
  }

  onSaveModel() {
    this.saveModel.emit();
  }

  onSaveModelDropDown() {
    this.onSaveModel();
  }

  onSelectedItemIdChange() {
    this.selectedItemIdChange.emit(this.selectedItemId);
  }

  get selectedItemName(): string {
    return this.selectedItemId ? this.selectedItemId.name : '';
  }

  get ThirdPartyConsentStatusEnum() {
    return ThirdPartyConsentStatusEnum;
  }

  consentIsSet(): boolean {
    return !!this.stakeholderName;
  }

  getBackgroundClass(consentStatus?: ThirdPartyConsentStatusEnum): string {
      switch (consentStatus) {
        case ThirdPartyConsentStatusEnum.UNKNOWN:
        case ThirdPartyConsentStatusEnum.MANUALLY:
          return 'consent-request-background-white';
        case ThirdPartyConsentStatusEnum.ORAL:
          return 'consent-request-background-yellow';
        case ThirdPartyConsentStatusEnum.CONSENT_ACCEPTED_WEB:
        case ThirdPartyConsentStatusEnum.CONSENT_ACCEPTED_MAN:
          return 'consent-request-background-green';
      }
      return '';
    }
}
